"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIssueProperty = void 0;
const react_1 = require("react");
const jiraEntity_1 = require("./jiraEntity");
const useEntityProperty_1 = require("./useEntityProperty");
/**
 * This function manages the properties of a Jira issue where the app is installed
 * @param propertyKey Name (key) of the property
 * @param initValue Default value if it did not exist previously
 * @returns An array with 3 items:
 *  1. Current value of the property.
 *  2. A function to update the property value (with another value or an updater function). If a <retryCount> is given and an initial update fails, it automatically tries to update for another <retryCount> times (default 0).
 *  3. A function to delete the property.
 */
const useIssueProperty = (propertyKey, initValue) => {
    const entityManager = (0, react_1.useMemo)(() => (0, jiraEntity_1.jiraIssuePropsManager)({
        entityType: 'Issue',
        origPropertyKey: propertyKey,
        initValue
    }), []);
    return (0, useEntityProperty_1.useEntityProperty)({ entityManager, defaultRetryCount: 0 }); // no update retries needed for issue properties
};
exports.useIssueProperty = useIssueProperty;
